import { Link } from "react-router-dom";
import React from "react";
import { MessageFormatElement } from "react-intl";
import { IRouteConfig } from "@lib/types/Routes";

const renderMenuItemChildren = (
  item: IRouteConfig,
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
): { key: string; icon: JSX.Element; label: JSX.Element } => {
  const { icon, messageId, url } = item;
  if (item?.dontShowInSidebar) return null;

  if (url && url.includes("/"))
    return {
      key: item.id,
      icon:
        icon &&
        (React.isValidElement(icon) ? (
          <span className="ant-menu-item-icon">{icon}</span>
        ) : (
          <span className="ant-menu-item-icon" />
        )),
      label: (
        <Link to={url}>
          <span data-testid={messageId.toLowerCase + "-nav"}>
            {messages[messageId] as string}
          </span>
        </Link>
      ),
    };
  else {
    return {
      key: item.id,
      icon:
        icon &&
        (React.isValidElement(icon) ? (
          <span className="ant-menu-item-icon">{icon}</span>
        ) : (
          <span className="ant-menu-item-icon" />
        )),
      label: (
        <span data-testid={messageId.toLowerCase + "-nav"}>
          {messages[messageId] as string}
        </span>
      ),
    };
  }
};

const renderMenuItem = (
  item: IRouteConfig,
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
) => {
  if (item?.dontShowInSidebar) return null;

  return item.type === "collapse"
    ? {
        ...renderMenuItemChildren(item, messages),
        children: item.children?.map((item) => renderMenuItem(item, messages)),
        type: "collapse",
      }
    : {
        ...renderMenuItemChildren(item, messages),
      };
};

const renderMenu = (
  item: IRouteConfig,
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
) => {
  if (item?.dontShowInSidebar) return null;

  return item.type === "group"
    ? {
        id: item?.id,
        url: item?.url,
        ...renderMenuItemChildren(item, messages),
        children: item.children?.map((item) => renderMenuItem(item, messages)),
        type: "group",
      }
    : {
        id: item.id,
        url: item.url,
        exact: item.exact,
        ...renderMenuItemChildren(item, messages),
      };
};

export const getRouteMenus = (
  routesConfig: IRouteConfig[],
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
) => {
  return routesConfig.map((route) => renderMenu(route, messages));
};
